// extracted by mini-css-extract-plugin
export default {"editCountry":"editCountry_editCountry__9momR","editCountry__head":"editCountry_editCountry__head__9kOP8"};